import ky from 'ky';

import type { GoogleAuthResult, SessionResult } from '@libs/auth/react';

/** Session endpoints live on this same worker — see app/routes/api/*. */
const api = ky.create({
  credentials: 'include',
  timeout: 30_000,
  retry: { limit: 0 },
  throwHttpErrors: false,
});

export async function getSession(): Promise<SessionResult> {
  try {
    return await api.get('/api/session').json<SessionResult>();
  } catch {
    return { valid: false, user: null };
  }
}

export async function googleAuth(idToken: string): Promise<GoogleAuthResult> {
  try {
    const response = await api.post('/api/auth/google', { json: { idToken } });
    const body = (await response.json().catch(() => null)) as GoogleAuthResult | null;
    if (!response.ok || !body) {
      return { success: false, error: body?.error ?? `Sign-in failed: ${response.status}` };
    }
    return body;
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Google sign-in failed';
    return { success: false, error: message };
  }
}

export async function logout(): Promise<void> {
  await api.post('/api/logout').catch(() => undefined);
}
